document.addEventListener('DOMContentLoaded', function() {
  const loadMoreBtn = document.getElementById('load-more-btn');
  const showLessBtn = document.getElementById('show-less-btn');
  const moreCollectionsContainer = document.getElementById('more-collections');
  
  if (!loadMoreBtn || !showLessBtn || !moreCollectionsContainer) {
    console.error('Un ou plusieurs éléments sont manquants');
    return;
  }
  
  // Bouton "Voir plus"
  loadMoreBtn.addEventListener('click', function() { 
    // Affiche les collections
    moreCollectionsContainer.style.display = 'grid';
    
    // Cache "Voir plus", affiche "Afficher moins"
    loadMoreBtn.style.display = 'none';
    showLessBtn.style.display = 'flex';  // ← Changé de 'block' à 'flex'
    
    // Transition d'opacité après un court délai
    setTimeout(() => {
      moreCollectionsContainer.style.opacity = '1';
    }, 10);
  });
  
  // Bouton "Afficher moins"
  showLessBtn.addEventListener('click', function() {
    // Commence la transition d'opacité
    moreCollectionsContainer.style.opacity = '0';
    
    // Attend la fin de la transition avant de cacher
    setTimeout(() => {
      moreCollectionsContainer.style.display = 'none';
      
      // Affiche "Voir plus", cache "Afficher moins"
      loadMoreBtn.style.display = 'flex';
      showLessBtn.style.display = 'none';
    }, 1000);  // 1 seconde pour correspondre à la transition CSS
  });
});
